<template>
  <div>
    <div class="row">
      <div class="col-2"></div>
      <div class="col-8">
        <b-card header="會員資料" class="mt-4 text-left">
          <div class="row">
            <div class="col-6 text-right">帳號</div>
            <div class="col-6 text-left">123</div>
          </div>
          <div class="row">
            <div class="col-6 text-right">密碼</div>
            <div class="col-6 text-left">123</div>
          </div>
          <div class="row">
            <div class="col-6 text-right">訂閱電子報</div>
            <div class="col-6 text-left">123</div>
          </div>
          <div class="row">
            <div class="col-6 text-right">註冊日期</div>
            <div class="col-6 text-left">123</div>
          </div>
        </b-card>
        <b-card header="個人資料" class="mt-4 text-left">
          <div class="row">
            <div class="col-6">
              <div class="row">
                <div class="col-6 text-right">姓名</div>
                <div class="col-6 text-left">123</div>
              </div>
              <div class="row">
                <div class="col-6 text-right">性別</div>
                <div class="col-6 text-left">123</div>
              </div>
              <div class="row">
                <div class="col-6 text-right">連絡電話</div>
                <div class="col-6 text-left">123</div>
              </div>
              <div class="row">
                <div class="col-6 text-right">地址</div>
                <div class="col-6 text-left">123</div>
              </div>
              <div class="row">
                <div class="col-6 text-right">最高學歷</div>
                <div class="col-6 text-left">123</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-6 text-right">電子報</div>
                <div class="col-6 text-left">123</div>
              </div>
              <div class="row">
                <div class="col-6 text-right">出生年月</div>
                <div class="col-6 text-left">123</div>
              </div>
              <div class="row">
                <div class="col-6 text-right">行動電話</div>
                <div class="col-6 text-left">123</div>
              </div>
              <div class="row">
                <div class="col-6 text-right">工作職業</div>
                <div class="col-6 text-left">123</div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-2"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
